// config/index.js
const baseUrl = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
const image_baseUrl = 'https://storage.googleapis.com/sta_images/'

export default {
    appurl: baseUrl,
    coupon: image_baseUrl + 'media/Coupon/',
    applogo: image_baseUrl + 'media/foodapp/original/',
    signInLogo: image_baseUrl + 'media/LoginSigupImage/',
    google_key: window.google_map_key,
    api_url: process.env.VUE_APP_API_URL, 
    socket_url: process.env.VUE_APP_SOCKET_URL,
    loadSharAPI: process.env.VUE_APP_LOADSHAR_API,
    title: process.env.VUE_APP_TITLE || 'STA',
};